<template>
  <template v-if="imageData">
    <template v-for="item, i in list" :key="i" >
      <TargetBox 
        :item="item"
        :imageDimensions="imageDimensions"
        :active="i === currentIndex"
        :successKey="successKey"
        v-on:click="$emit('clickBox', i)"
      />
    </template>
  </template>
</template>

<script>
import TargetBox from './TargetBox'
export default {
  props: [
    'list',
    'baseImageUrl',
    'imageDimensions',
    'currentIndex',
    'successKey'
  ],
  data() {
    return {
      imageData: false
    }
  },
  created() {
    this.getImageData()
  },
  emits: [
    'clickBox'
  ],
  methods: {
    getImageData() {
      const img = new Image()
      this.imageData = false

      img.onload = ()=> {
        this.imageData = {
          width: img.naturalWidth,
          height: img.naturalHeight
        }
      }

      img.src = this.baseImageUrl
    },
    
  },
  components: {
    TargetBox
  }
}
</script>